<template>
  <div class="transliterate">


    <div class="input-area">
      <button v-bind:class="{selected: transliterate.language == 'kazakh'}" @click="setLanguage('kazakh')">Kazakh</button>
      <button v-bind:class="{selected: transliterate.language == 'kyrgyz'}" @click="setLanguage('kyrgyz')">Kyrgyz</button>
      <button v-bind:class="{selected: transliterate.language == 'uyghur'}" @click="setLanguage('uyghur')">Uyghur</button>

      <textarea v-model="transliterate.original" type="text"/>
      <button class="convert" @click="convert(transliterate)">Transliterate</button>

      </div>
    <div class="result-area">
      <button v-bind:class="{selected: transliterate.outputScript == 'arabic'}" @click="setOutputScript('arabic')">Arabic</button>
      <button v-if="transliterate.language == 'kazakh'" v-bind:class="{selected: transliterate.outputScript == 'latin'}" @click="setOutputScript('latin')">Latin (XJ*)</button>
      <pre class="text" v-bind:class="{arabic: transliterate.outputScript == 'arabic'}"><div id="editable" contenteditable="true" ref="result" onfocus="document.execCommand('selectAll',false,null);">{{ transliterate.result }}</div></pre>
      <button @click="selectAndCopy()"> Copy to Clipboard </button>
      <br>
      <span v-if="transliterate.language == 'kazakh'">*Latin standard used in Xinjiang (1964-84)</span>

      </div>
  </div>
</template>

<script>
export default {
  name: "Transliterate",
  props: {
    transliterate: Object
  },
  methods: {
    selectAndCopy() {
      this.$copyText(this.transliterate.result);
      this.$refs.result.focus();
    },
    convert(transliterate) {
      this.$store.dispatch("convert", transliterate);
    },
    setOutputScript(script) {
      this.transliterate.outputScript = script;
      this.$store.dispatch("convert", this.transliterate);
    },
    setLanguage(language) {
      this.transliterate.language = language;
      if (language != "kazakh") {
        this.transliterate.outputScript = "arabic";
      }
      this.$store.dispatch("convert", this.transliterate);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.transliterate {
  display: flex;
  height: 100%;
  flex-flow: row wrap;
  justify-content: space-around;
  > * {
    flex: 1;
    min-width: 400px;
    padding: 25px;
    // max-height: 90%;
    // min-height: 150px;
  }

  .input-area {
    textarea {
      font-family: sans-serif;
      font-size: 24px;
      color: black;
      width: 100%;
      padding: 10px;
      height: 90%;
    }
  }

  .result-area {
    .text {
      border: dotted 2px #42b983;
      margin: 0px;
      font-family: sans-serif;
      font-weight: normal;
      background-color: whitesmoke;
      font-size: 24px;
      color: black;
      width: 100%;
      height: 90%;
      text-align: left;
      padding: 10px;
      overflow: scroll;
      white-space: pre-wrap;
      word-wrap: break-word;

      #editable {
        outline: none;
      }

      &.arabic {
        font-family: Kaznet;
        direction: rtl;
        text-align: right;
      }
    }
  }
}

button {
  &.convert {
    width: 100%;
    color: #42b983;
    height: 40px;
    font-size: 20px;
    /* border: 5px solid orange; */
    background-color: #42b983;
    color: white;
    font-weight: bold;
  }

  border: none;
  outline: none;
  cursor: pointer;
  height: 30px;
  font-size: 15px;
  background: #f5f5f5;
  &.selected {
    background-color: rgb(66, 185, 131);
    color: white;
  }
}

h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
